import React from "react";
import { MapPin, Map as MapIcon, Navigation, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const suburbs = ["Kanata", "Nepean", "Centretown", "The Glebe", "Westboro", "Orleans", "Barrhaven", "Stittsville", "Rockcliffe Park", "Sandy Hill", "Vanier", "Gloucester", "Alta Vista", "Manotick", "Hunt Club", "Hintonburg", "Old Ottawa South", "Carlington", "Lowertown", "Overbrook", "New Edinburgh", "ByWard Market", "Civic Hospital", "Little Italy"];
const trustPoints = [{
  id: 1,
  label: "Local Ottawa service"
}, {
  id: 2,
  label: "Free pickup. No hidden fees"
}, {
  id: 3,
  label: "Clothing donated to local charities"
}];
export default function OurCanberraServiceMap() {
  return <section data-section-id="160943" id="where-we-pick-up" className="relative w-full py-28 lg:py-40 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623234/img/ottawa_porch_donation_bags.png)] bg-cover bg-center opacity-15 mix-blend-multiply grayscale"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background via-transparent to-background"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 lg:mb-20">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-6">
            <MapIcon className="size-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight mb-6">
            Where We Pick Up in Ottawa
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground/90 max-w-3xl font-default leading-relaxed">
            Providing convenient, no-contact clothing collection across the capital region. We visit different neighborhoods every week—find yours below and help your community.
          </p>
        </div>

        {}
        <div className="max-w-5xl mx-auto bg-card/80 backdrop-blur-xl border border-border shadow-xl rounded-2xl p-6 md:p-10 lg:p-12">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-3">
            {suburbs.map((suburb, i) => <div key={suburb} data-index={i} className="group flex items-center gap-3 p-2.5 rounded-lg hover:bg-primary/5 hover:shadow-sm transition-all duration-300 cursor-default border border-transparent hover:border-primary/10">
                <div className="flex-shrink-0 flex items-center justify-center size-8 rounded-full bg-accent/50 group-hover:bg-primary/20 transition-colors duration-300">
                  <MapPin className="size-4 text-primary group-hover:text-primary transition-colors duration-300" />
                </div>
                <span className="text-sm md:text-base font-default font-medium text-foreground/80 group-hover:text-primary transition-colors duration-300">
                  {suburb}
                </span>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-20 max-w-3xl mx-auto text-center">
          <div className="inline-flex flex-col items-center p-8 md:p-12 bg-accent/20 rounded-3xl border border-border/50">
            <Navigation className="size-8 text-primary mb-6 opacity-80" />
            <p className="text-xl md:text-2xl text-foreground font-default font-semibold mb-8">
              Live just outside the city? We cover Kanata on Mondays, Nepean on Tuesdays, and Downtown on Wednesdays!
            </p>
            
            {}
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 md:gap-8 mb-4">
              {trustPoints.map((point, i) => <div key={point.id} data-index={i} className="flex items-center gap-2 text-muted-foreground/90">
                  <CheckCircle2 className="size-5 text-primary" />
                  <span className="text-sm md:text-base font-medium">{point.label}</span>
                </div>)}
            </div>

            <Button asChild size="lg" className="mt-10 rounded-full px-10 py-7 text-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg hover:shadow-xl transition-all">
              <Link to="#">
                Schedule a Free Pickup
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}